export default __webpack_public_path__ + "static/media/HI_New.86f0b4e8.png";